import type { FinixProxyRequest } from '@/lib/finixProxy';
import type { BackendRouteDefinition } from '../types';

/**
 * Migrated to `api-core-node` in PRA-776 (Phase 5 Sub-phase 1). The original
 * `finixProxy` cloud function (an `onRequest` HTTP handler, not a callable)
 * is intentionally left deployed for rollback until the Sub-phase 9
 * retirement sweep.
 */
export const callFinixProxyRoute = {
  transport: 'api',
  method: 'POST',
  path: '/admin/finix/proxy',
  body: (requestData: FinixProxyRequest) => requestData,
} as const satisfies BackendRouteDefinition;
